<template>
    <rkm-layout-body title="Lista de unidade">
        <template v-slot:actions>
            <rkm-button
                @click="openCadastroUnidadeConectaSus"
                authorize="store-cadastro-unidade"
                color="primary"
            >
                Cadastrar unidade (ConectaSUS)
            </rkm-button>

            <rkm-button
                @click="$router.push({name: 'web-service-almoxarifado-cliente-unidade-create'})"
                authorize="store-web-service-almoxarifado-cliente-unidade"
                color="primary"
            >
                Cadastrar unidade
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/web-service/almoxarifado/cliente/unidade/List'

export default {
    components: {List},
    methods: {
        openCadastroUnidadeConectaSus() {
            window.open(this.$router.resolve({name: 'cadastro-unidade-create'}).href, '_blank')
        },
    },
}
</script>